import { initSignOut } from '../ui/sign_out';

document.addEventListener("turbo:load", () => {
    initSignOut();
});